import React, { useEffect, useState, FC } from "react";
import {
  GetStoreRequisitiontList,
  ExportPdf,
} from "../../api/storeRequisition";
import {
  filterParams,
  generateExportedFile,
  convertToServerFormat,
} from "../../helpers/function.helper";
import { useGlobalState } from "../../context/Provider";
import TableForm from "../../components/tableForm";
import { useSearchParams } from "react-router-dom";
import { columns, datahelper } from "../../helpers/storeRequest.helper";
import StoreRequestDetail from "../../components/storeRequisitionDetail";
import { Row, Col, Table, Pagination } from "antd";
import TableTotalCount from "../../components/tableTotalCount";

const StoreRequisition: FC = () => {
  const [searchParams]: any = useSearchParams();
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any>([]);
  const [total, setTotal] = useState<number>(0);
  const [form, setForm] = useState<any>(Object.fromEntries([...searchParams]));
  const { langState }: any = useGlobalState();

  useEffect(() => {
    handleStroreRequestApi();
  }, [form, page]);

  const handleStroreRequestApi = () => {
    console.log("form is", form);
    setLoading(true);
    const params = {
      SkipCount: (page - 1) * 40,
      StartDate: form.rangeDate && convertToServerFormat(form.rangeDate[0]),
      EndTime: form.rangeDate && convertToServerFormat(form.rangeDate[1]),
      CreatorEmail: form.CreatorEmail,
      EntryAndExit: form.EntryAndExit,
      Type: form.Type,
    };
    const fp = filterParams(params);

    GetStoreRequisitiontList(fp).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        setData(datahelper(res.data.items, page));
        setTotal(res.data.totalCount);
      }
    });
  };
  const handleGetExport = (id: number) => {
    setLoading(true);
    const params = {
      html: "",
      fileName: "",
    };
    ExportPdf(id, params).then((res: any) => {
      setLoading(false);
      if (res.status === 200) {
        generateExportedFile(res.data, "pdf");
      }
    });
  };
  return (
    <>
      <Row gutter={[0, 24]} justify="center">
        <Col xs={0} md={23}>
          <TableForm setForm={setForm} setFormData={()=>{}} />
        </Col>
        <Col span={23}>
          <Table
            columns={columns(langState.locale, handleGetExport)}
            dataSource={data}
            size="middle"
            pagination={false}
            scroll={{ x: 1100, y: "calc(100vh - 210px)" }}
            loading={loading}
            expandable={{
              expandedRowRender: (info: any) => {
                return (
                  <>
                    <StoreRequestDetail id={info.id} />
                  </>
                );
              },
            }}
          />
        </Col>
        <Col span={23}>
          <Row justify="space-between" align="middle">
            <Col>
              <Pagination
                defaultCurrent={1}
                total={total}
                defaultPageSize={40}
                showSizeChanger={false}
                onChange={(number) => setPage(number)}
              />
            </Col>
            <Col>
              <TableTotalCount total={total} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default StoreRequisition;
